import get from 'lodash/get';
import axios from 'axios';

import actionTypes from './actionTypes';
import store from '../store/store';

import { API_CONFIG } from '../../config/api.config';

const createHeaders = () => {
	const state = store.getState();
	const langTag = store.getState().head.language.toUpperCase();
	const lang = (store.getState().head.utilities.languages.find(lng => lng.tag === langTag) || { uuid: localStorage.getItem('langUuid') || undefined }).uuid;
	const token = state.cms.authentication.token || localStorage.getItem('token');

	return { headers: { lang: lang || '489d6ac3-7b65-42c1-bdc6-67348bf7a112', token } };
};

export const fetchingFailed = () => (dispatch) => {
	dispatch({
		type: actionTypes.FETCHING_FAILED,
	});
};
export const fetchingSucceeded = () => (dispatch) => {
	dispatch({
		type: actionTypes.FETCHING_SUCCEEDED,
	});
};
export const fetchingInProgress = () => (dispatch) => {
	dispatch({
		type: actionTypes.FETCHING_IN_PROGRESS,
	});
};

const updateProjectSettings = ({ limit, offset }) => {
	const currentLimit = limit || get(store, 'content.projects.limit', 6);
	const currentOffset = get(store, 'content.projects.offset', 0);
	const nextOffset = offset ? currentOffset + offset + currentLimit : currentOffset + currentLimit;

	return { limit: currentLimit, offset: nextOffset };
};
export const fetchProjects = (limit, offset) => (dispatch) => {
	updateProjectSettings({ limit, offset });
	const body = createHeaders();

	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.PROJECT}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_PROJECTEN,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};
export const fetchProjectsAll = (limit, offset) => (dispatch) => {
	updateProjectSettings({ limit, offset });
	const body = createHeaders();

	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.POJECT_ALL}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_PROJECTEN,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};
export const searchProjects = search => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.SEARCH_PROJECT}/${search}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.SEARCH_PROJECTS,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};
export const fetchProjectDetail = slug => (dispatch) => {
	const body = createHeaders();
	const data = store.getState().content.projects.result.find(item => item.slug === slug);

	if (!data) {
		axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.PROJECT}`, body)
			.then((result) => {
				dispatch({
					type: actionTypes.FETCH_PROJECT_DETAIL,
					data: result.data.data.find(item => item.slug === slug),
				});
				dispatch(fetchingSucceeded());
			})
			.catch(() => dispatch(fetchingFailed()));
		return;
	}

	dispatch({
		type: actionTypes.FETCH_PROJECT_DETAIL,
		data,
	});
};

export const fetchDocuments = () => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.DOCUMENT}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_DOCUMENTS,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};

export const searchDocuments = search => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.SEARCH_DOCUMENT}/${search}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.SEARCH_DOCUMENTS,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};

export const fetchTestimonies = () => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.TESTIMONIES}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_TESTIMONIES,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};
export const fetchReferences = () => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.REFERENCE}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_REFERENCES,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};
export const fetchUsers = () => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.USER}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_USERS,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};

export const searchAtex = search => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.SEARCH_ATEX}/${search}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.SEARCH_ATEX,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};

export const fetchAtex = () => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.ATEX}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.SEARCH_ATEX,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};
export const fetchAtexAll = () => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.ATEX_ALL}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.SEARCH_ATEX,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};

export const fetchFAQ = () => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.FAQ}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_FAQ,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};

export const fetchFAQAll = () => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.FAQ_ALL}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_FAQ,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};


export const fetchFAQById = id => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.FAQ}/${id}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_FAQ_BY_ID,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};

export const fetchCategories = (type = 'household') => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.PRODUCT_CATEGORY}/${type}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_CATEGORIES,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};

export const fetchCategoriesAll = (type = 'household') => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.PRODUCT_CATEGORY_ALL}/${type}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_CATEGORIES,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};

export const searchCategories = search => (dispatch) => {
	const body = createHeaders();
	dispatch(fetchingInProgress());

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.SEARCH_PRODUCT_CATEGORY}/${search}`, body)
		.then((data) => {
			dispatch({
				type: actionTypes.SEARCH_CATEGORIES,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};



// WEBPACK FOOTER //
// ./src/redux/content/contentActions.js